import { Button, Card, Form, notification } from 'antd'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import { DisplayDate } from '../../../../components/_utils/appUtils'
import { getAllAbstracts } from '../../views/actions'
import { ResendAbstractComments } from '../actions'
import { chooseEmailModalFxn } from '../../../../components/_utils/appUtils'
import AbstractFilters from '../abstractPages/AbstractFilters'
import AbstractActivityList from '../../views/AbstractActivityList'
// Import your Abstract-specific drawer for receiving revised abstracts
import RevisedAbstractDrawer from '../abstractPages/RevisedAbstractDrawer'

@Form.create()
class CommentsToAuthorAbstracts extends Component {
  state = {
    filters: {},
    visibleRevisedAbstract: false,
    abstract: {},
    total: '',
    visibleActivityList: false
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      let { dispatch } = this.props
      let obj = {
        ...params,
        ...this.state.filters,
        status: 'Comments To Author' // Targeted status for this page
      }
      let data = await dispatch(getAllAbstracts(obj))
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  reload = () => {
    this.table.current.reload()
  }

  reloadTable = data => {
    if (data.fromDate && data.toDate) {
      data['createdAt'] = { $gte: data.fromDate, $lte: data.toDate }
      delete data['fromDate']
      delete data['toDate']
    }
    this.setState({ filters: data }, () => this.reload())
  }

  handleResend = (record) => {
    const { dispatch } = this.props;
    chooseEmailModalFxn({
      title: 'Send Comments to Author',
      callback: async (email) => {
        let valData = {
          abstractId: record._id,
          id: record._id,
          fromEmail: email,
          flag: 'Abstract'
        };

        // Dispatch the action to your backend
        let resp = await dispatch(ResendAbstractComments(valData));

        // Refresh the table if successful
        if (resp && resp.success) {
          dispatch({ type: 'START_LOAD_ABSTRACT' });
          this.reload();
        }
      }
    });
  }

  render() {
    const columns = [
      {
        title: 'Abstract No.',
        key: 'abstractNo',
        dataIndex: 'abstractNo',
        width: 150, // Slightly wider to fit the strings!
        render: (val, record) => (
          <a href={`/abstract/view/${record._id}`}>
            {record.abstractNo || record.onlineAbstractId || 'N/A'}
          </a>
        )
      },
      {
        title: 'Submitted Date',
        key: 'createdAt',
        dataIndex: 'createdAt',
        render: item => DisplayDate(item)
      },
      {
        title: 'Title',
        key: 'titleOfAbstract',
        dataIndex: 'titleOfAbstract'
      },
      {
        title: 'Comments Sent',
        key: 'sendToAuthorDate',
        dataIndex: 'sendToAuthorDate',
        render: item => DisplayDate(item)
      },
      {
        title: 'Comments Received',
        key: 'receiveDate',
        render: (val, record) => {
          const date = record.selectedReviewer && record.selectedReviewer.length > 0
            ? record.selectedReviewer[0].receiveDate
            : null;

          return date ? DisplayDate(date) : null;
        }
      },
      {
        title: 'Action',
        key: 'Action',
        render: (item, record) => (
          <>
            <Button className={'roundSmallBtn'} onClick={() => this.handleResend(record)}>
              Resend Comments
            </Button>
            <Button className={'roundSmallBtn'} onClick={() => this.setState({ visibleRevisedAbstract: true, abstract: record })}>
              Revised Abstract
            </Button>
            <Button className={'roundSmallBtn'} onClick={() => this.setState({ visibleActivityList: true, abstract: record })}>
              Activities
            </Button>
          </>
        )
      }
    ]

    return (
      <PageHeaderWrapper title={`Comments To Author (${this.state.total})`}>
        <Card bordered={true}>
          <AbstractFilters callback={data => this.reloadTable(data)} />
          <TableComp ref={this.table} columns={columns} apiRequest={this.apiRequest} />
        </Card>

        {this.state.visibleRevisedAbstract && (
          <RevisedAbstractDrawer
            visible={this.state.visibleRevisedAbstract}
            abstractId={this.state.abstract._id}
            abstract={this.state.abstract}
            callback={this.reload}
            onClose={() => this.setState({ visibleRevisedAbstract: false })}
          />
        )}

          {this.state.visibleActivityList && (
              <AbstractActivityList
                abstractId={this.state.abstract._id}
                abstractIdNo={this.state.abstract.abstractNo || this.state.abstract.onlineAbstractId || 'N/A'}
                visible={this.state.visibleActivityList}
                onClose={() => this.setState({ visibleActivityList: false })}
              />
            )}

      </PageHeaderWrapper>
    )
  }
}

export default connect()(CommentsToAuthorAbstracts)
